import PropTypes from 'prop-types'
import React from 'react'

const Decoration = ({ className = '' }) => {
  return (
    <svg
      className={className}
      width="998"
      height="120"
      viewBox="0 0 998 120"
      fill="none"
      preserveAspectRatio="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M998 31.8382C949.989 13.661 744.82 0 499 0C253.18 0 48.0113 13.661 0 31.8382V40H998V31.8382Z"
        fill="#212121"
      />
      <path
        d="M998 31.8382C949.989 13.661 744.82 0 499 0C253.18 0 48.0113 13.661 0 31.8382V40H998V31.8382Z"
        fill="white"
        fillOpacity="0.9"
      />
      <rect y="40" width="998" height="80" fill="#212121" />
    </svg>
  )
}

Decoration.propTypes = {
  className: PropTypes.string,
}

export default Decoration
